import React from 'react';
import ManagementCampaignContainer from '../../containers/ManagementCampaign';

const ManagementPage: React.FC = () => <ManagementCampaignContainer />;

export default ManagementPage;
